import _ from 'lodash';

import c from 'common/constants/flux-events';
import mergeResource from 'utils/merge-resource';

export const NAME = 'resources.ubxAudiences';
export default function reducer(state = {}, action) {
    switch (action.type) {
        case 'SYSTEM__UBX_AUDIENCES__FETCH__SUCCESS':
            const { audience, audiences } = action.payload;
            return mergeResource(
                state,
                []
                    .concat(audience)
                    .concat(audiences)
                    .filter(x => x)
            );
        default:
            return state;
    }
}
